import { FileModel, FileSource } from '@aiwyn/shared';

import { FileDisplay } from './file-item.model';

export interface FileItemPreviewList {
  files: FileModel[];
  initialIndex: number;
}

export function buildFileItemPreviewList(siblings: FileDisplay[] | undefined, clicked: FileDisplay): FileItemPreviewList {
  const previewable = (siblings ?? [clicked]).filter((file) => !file.isMasked && (file.dmsId || file.dmsFileId));
  const files = previewable.map((file) => ({
    id: file.id,
    fileSource: FileSource.CLIENT_REQUEST,
    name: `${file.name}.${file.extension}`,
    dmsFileId: file.dmsId ?? file.dmsFileId,
  }));
  const initialIndex = Math.max(
    0,
    previewable.findIndex((file) => file.id === clicked.id),
  );
  return { files, initialIndex };
}
